import { createFileRoute } from "@tanstack/react-router";
import { ProductPage } from "../features/catalog/ProductPage";

/** `/catalog/<slug>` — one product, its agent progress, and what it costs. */
export const Route = createFileRoute("/catalog/$slug")({
  component: () => <ProductPage slug={Route.useParams().slug} />,
});
